import { useContext, useEffect, useRef, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import SubjectRegistrationForm from "../ones/SubjectRegistrationForm";
import ExamCycleCreationForm from "../ones/ExamCycleCreationForm";
import { MdPrint, MdWarning } from "react-icons/md";
import { useReactToPrint } from "react-to-print";

export default function View({ examCycleUuid }) {

	const appContext = useContext(AppContext);
	const sheetsRef = useRef(null);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [examCycleData, setExamCycleData] = useState(null);
	const [examCycleResults, setExamCycleResults] = useState(null);
	const [loading, setLoading] = useState(false);
	const [examCycleFor, setExamCycleFor] = useState('classroom');


	const printSheet = useReactToPrint({
		contentRef: sheetsRef,
		documentTitle: "Results Sheet", // optional
	});
		
	
	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getExamCycleData(),
			getExamCycleResults(),
			appContext.getMySubjects(),
			appContext.getAllSubjects(),
		])
		setReady(true);
	}

	async function getExamCycleData() {
		await callApi("get-exam-cycle-data", { uuid: examCycleUuid }).then(response => {
			if (response.status === 1) {
				setExamCycleData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}

	async function getExamCycleResults() {
		await callApi("get-exam-cycle-results", { uuid: examCycleUuid }).then(response => {
			if (response.status === 1) {
				setExamCycleResults(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}

	function getSubjectName(subjectUuid) {
		let name = '';

		if(appContext.allSubjects) {
			const subject = appContext.allSubjects.find((item, i) => item.uuid === subjectUuid);

			if(subject) {
				name = subject.name;
			}
		}

		return name;
	}

	function canStaffEditThisSubjectMarks(subjectUuid) {
		let canEdit = false;

		
		
		if(appContext.mySubjects && examCycleData) {
			for (const mySubject of appContext.mySubjects) {

				if(examCycleFor === 'classroom') {
					
					if(
						mySubject.classOrStreamUuid === examCycleData.classroomUuid &&
						mySubject.uuid === subjectUuid
					) {
						canEdit = true;						
						break;
					}
				} else if(examCycleFor === 'stream') {
					if(
						mySubject.classOrStreamUuid === examCycleData.streamUuid &&
						mySubject.uuid === subjectUuid
					) {
						canEdit = true;
						break;
					}
				}
			}
		}

		return canEdit;
	}

	function handleExamCycleResultsMarksChange(studentUuid, subjectUuid, marks) {
		setExamCycleResults(_prev => {
			const _new = [..._prev];

			const student = _new.find((item, i) => item.uuid === studentUuid);
			const studentAllExamResults = JSON.parse(student.examResults);
			const currentCycleStudentResults = studentAllExamResults.find((item, i) => item.examCycleUuid === examCycleUuid);
			const subjectInScope = currentCycleStudentResults.subjects.find((item, i) => item.uuid === subjectUuid);
			subjectInScope.marks = marks;
			student.examResults = JSON.stringify(studentAllExamResults);

			saveExamResults(studentUuid, subjectUuid, marks);

			return _new;
		})
	}

	async function saveExamResults(studentUuid, subjectUuid, marks) {
		await callApi('save-exam-results-for-student', { studentUuid, subjectUuid, marks, examCycleUuid }).then((response) => {
			if(response.status === 1) {
				//appContext.tellMessage("Results were updated")
			} else {
				//only say if there was an error
				appContext.tellError(response.msg);
			}
		})
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	useEffect(() => {
		if(examCycleData) {
			if(examCycleData.classroomUuid && examCycleData.streamUuid) {
				setExamCycleFor('stream');
			} else if(examCycleData.classroomUuid && !examCycleData.streamUuid) {
				setExamCycleFor('classroom');
			}
		}
	}, [ examCycleData ])

	if (ready && examCycleData) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							Exam Cycle Results Editor
						</h6>
						<hr/>
					</div>

					

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body" style={{ overflowX: "auto" }}>

								<h6 className="card-title">Results</h6>
								<hr/>

								<div className="text-end">
									<button
										className="btn btn-sm btn-outline-dark"
										onClick={printSheet}
									>
										<MdPrint size={18}/> Print Sheet
									</button>
								</div>

								{
									(examCycleData.isProcessed === 'no') ?
									<div className="text-start">
										<h6
											style={{
												fontSize: "14px"
											}}
											className="text-success font-semi-bold"
										>
											<MdWarning size={18}/>
											<br/>
											Results are updated as you type, if an error occurs you will be notified
										</h6>
									</div>
									:""
								}

								{
									(examCycleData.isProcessed === 'yes') ?
									<div className="text-start">
										<h6
											style={{
												fontSize: "14px"
											}}
											className="text-danger font-semi-bold"
										>
											<MdWarning size={18}/>
											<br/>
											Results are locked for further editing because this exam cycle was closed
										</h6>
									</div>
									:""
								}


								<div style={{ overflowX: "auto" }}>
									<div
										style={{
											minWidth: "700px",
											fontSize: "14px"
										}}
										ref={sheetsRef}
									>

										<div className="row">
											
											<div className="col-md-12 mt-2 mb-2">
												<label className="form-label">Exam Cycle Title</label>
												<h6
													style={{
														fontSize: "18px"
													}}
												>
													{examCycleData.title}
												</h6>
											</div>

											<div className="col-4 mt-2 mb-2">
												<label className="form-label">Status</label>
												<h6
													style={{
														fontSize: "18px"
													}}
												>
													{examCycleData.status}
												</h6>
											</div>

											<div className="col-4 mt-2 mb-2">
												<label className="form-label">Start Date</label>
												<h6
													style={{
														fontSize: "18px"
													}}
												>
													{formatDate(examCycleData.dateStart).substring(0, 10)}
												</h6>
											</div>

											<div className="col-4 mt-2 mb-2">
												<label className="form-label">End Date</label>
												<h6
													style={{
														fontSize: "18px"
													}}
												>
													{formatDate(examCycleData.dateEnd).substring(0, 10)}
												</h6>
											</div>

											<div className="col-4 mt-2 mb-2">
												<label className="form-label">Classroom</label>
												<h6
													style={{
														fontSize: "18px"
													}}
												>
													{examCycleData.classroomData?.name || "N/A"}
												</h6>
											</div>

											<div className="col-4 mt-2 mb-2">
												<label className="form-label">Stream</label>
												<h6
													style={{
														fontSize: "18px"
													}}
												>
													{examCycleData.streamData?.name || "N/A"}
												</h6>
											</div>
											
										</div>

										<table
											className="table table-striped table-bordered mt-5 mb-5"
										>
											<thead>
												<tr>
													<th>Student's Names</th>
													{
														JSON.parse(examCycleData.applicableSubjects).map((item, i) => {
															if(canStaffEditThisSubjectMarks(item)) {
																return (
																	<th key={i}>{getSubjectName(item)}</th>
																)
															}
														})
													}
												</tr>
											</thead>

											{
												(examCycleResults && examCycleResults.length > 0) ?
												<tbody>
													{
														examCycleResults.map((student, studentIndex) => {
															const allStudentResults = JSON.parse(student.examResults);
															const currentCycleStudentResults = allStudentResults.find((item, i) => item.examCycleUuid === examCycleUuid);

															return (
																<tr key={studentIndex}>
																	<td style={{ textTransform: "uppercase" }}>{student.firstName} {student.middleName} {student.lastName}</td>
																	{
																		JSON.parse(examCycleData.applicableSubjects).map((applicableSubject, applicableSubjectIndex) => {
																			if(canStaffEditThisSubjectMarks(applicableSubject)) {
																				const subjectInScope = currentCycleStudentResults.subjects.find((item3, i3) => item3.uuid === applicableSubject);

																				return (
																					<td key={applicableSubjectIndex}>
																						<input
																							className="form-control"
																							value={subjectInScope?.marks || ''}
																							onChange={(e) => {
																								handleExamCycleResultsMarksChange(student.uuid, subjectInScope.uuid, e.target.value)
																							}}
																							readOnly={(examCycleData.isProcessed === 'yes')}
																						/>
																					</td>
																				)
																			}
																		})
																	}
																</tr>
															)
														})
													}
												</tbody>
												:""
											}
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>


				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}